import styled from "styled-components";
import { theme } from "uikit";

const Data = styled.div`
	font-family: "Lato";
	font-style: normal;
	font-weight: 600;
	font-size: 12px;
	line-height: 16px;

	color: ${theme.colors.secondary};
`;

export default Data;
